export const chicagoCoordinates: Record<string, { lat: number; lng: number }> = {
  '401 North Wabash Avenue': { lat: 41.8891, lng: -87.6268 },
  '53 E Randolph St': { lat: 41.8845, lng: -87.6256 },
  '201 E Randolph St': { lat: 41.8827, lng: -87.6233 },
  '111 S Michigan Ave': { lat: 41.8796, lng: -87.6237 },
  '333 W 35th St': { lat: 41.83, lng: -87.6338 },
  '444 N Michigan Ave': { lat: 41.8906, lng: -87.6244 },
  '112 N Green St': { lat: 41.8839, lng: -87.6487 },
  '2301 S Martin Luther King Dr': { lat: 41.8515, lng: -87.6162 },
  '1400 S DuSable Lake Shore Dr': { lat: 41.8663, lng: -87.617 },
  '1200 S DuSable Lake Shore Dr': { lat: 41.8676, lng: -87.6134 },
  '626 N State St': { lat: 41.8929, lng: -87.6279 },
  '738 N Western Ave': { lat: 41.8953, lng: -87.6868 },
  '112 E Wacker Dr': { lat: 41.888, lng: -87.6237 },
  '233 S Wacker Drive': { lat: 41.8789, lng: -87.6359 },
  '550 E Grand Ave': { lat: 41.8925, lng: -87.6131 },
  '12 S Michigan Ave': { lat: 41.8816, lng: -87.6247 },
  'Grant Park': { lat: 41.8806, lng: -87.6207 },
  'Butler Field, Grant Park': { lat: 41.8786, lng: -87.6205 },
  '439 N Wells St': { lat: 41.8905, lng: -87.6338 },
  '2021 W Fulton St': { lat: 41.8867, lng: -87.6788 },
  '800 W Superior St': { lat: 41.896, lng: -87.6477 },
  '809 W Randolph St': { lat: 41.8842, lng: -87.6486 },
  '376 N County Line Rd, Gary, IN': { lat: 41.6228, lng: -87.2101 },
  '101 Rice St, Michigan City, IN': { lat: 41.7077, lng: -86.9311 },
  '208 Wabash St, Michigan City, IN': { lat: 41.7069, lng: -86.8986 },
  '1028 N Rush St': { lat: 41.9014, lng: -87.6267 },
  '11 W Erie St': { lat: 41.8938, lng: -87.6297 },
  '955 W Randolph St': { lat: 41.8846, lng: -87.6513 },
  '177 N State St': { lat: 41.8848, lng: -87.6279 },
  '600 E Grand Ave': { lat: 41.8919, lng: -87.6051 },
  '52 W Illinois St': { lat: 41.8907, lng: -87.6319 },
  'Michigan Avenue': { lat: 41.8951, lng: -87.6244 },
  '1901 W Madison St': { lat: 41.8807, lng: -87.6742 },
  '6156 S St Lawrence Ave': { lat: 41.7828, lng: -87.6106 },
  '6014 S Cottage Grove Ave': { lat: 41.7853, lng: -87.6062 },
  '63rd St & Cottage Grove Ave': { lat: 41.7802, lng: -87.6058 },
  'Midway Plaisance': { lat: 41.7868, lng: -87.596 },
  '805 S State St': { lat: 41.8714, lng: -87.6273 },
  '1255 S State St': { lat: 41.8658, lng: -87.6273 },
  "O'Hare International Airport": { lat: 41.9786, lng: -87.9048 },
};

export const chicagoCenter = { lat: 41.883, lng: -87.63 };
